import graphql from '@modules/graphql'

const { request, setToken } = graphql({
  endpoint: import.meta.env.VITE_BFF_MIDDLEWARE,
  batch: false
})

export { setToken }

export default request
